
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/carpet-and-upholstery-cleaning",
      function () {
        return require("private-next-pages/services/carpet-and-upholstery-cleaning/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/carpet-and-upholstery-cleaning"])
      });
    }
  